import api from "@/assets/js/utils/api.js"; // 控制 axios 設定區域
import { showCustom } from "@/assets/js/utils/alertService";
import Swal from "sweetalert2";

export default {
  name: "InventoryPage",

  data() {
    return {
      searchQuery: "", // 控制搜尋文字區域
      currentPage: 1, // 控制目前頁碼區域
      itemsPerPage: 5, // 控制每頁顯示數量區域

      showAdjustModal: false, // 控制 Modal 顯示區域
      adjustItem: {}, // 控制調整物件區域

      showBatchModal: false, // 控制批量 Modal 顯示
      batchAdjustForm: {
        stock: null,
        safetyStock: null,
      },

      inventory: [], // 控制 API 資料存放區域
      loading: false, // 控制載入狀態區域
      selectedIds: [], // 儲存勾選的項目 ID

      // 庫存調整紀錄相關
      showAdjustmentRecordsModal: false, // 控制庫存調整紀錄 Modal 顯示
      adjustmentRecords: [], // 假資料：庫存調整紀錄
      employees: [], // 員工列表
      recordFilters: {
        startDate: "", // 開始日期
        endDate: "", // 結束日期
        createdBy: "", // 操作人員
      },
      recordCurrentPage: 1, // 庫存調整紀錄分頁
      recordItemsPerPage: 10, // 庫存調整紀錄每頁顯示數量
      recordDateError: "", // 日期驗證錯誤信息
      todayDate: "", // 今天的日期（YYYY-MM-DD）

      // 用戶角色相關
      userRole: "", // 用戶角色（工程師、平台總管等）
    };
  },

  async mounted() {
    // 初始化今天的日期
    this.todayDate = this.getTodayString();
    await this.loadInventory(); // 控制初始化載入區域
    await this.loadUserRole(); // 載入用戶角色
    // 不再在掛載時載入，改為在打開模態框時才載入
  },

  watch: {
    showAdjustmentRecordsModal(newVal) {
      // 當模態框打開時，載入調整紀錄和員工列表
      if (newVal) {
        if (this.adjustmentRecords.length === 0) {
          this.fetchAdjustmentRecords();
        }
        if (this.employees.length === 0) {
          this.fetchEmployees();
        }
      }
    },

    "recordFilters.endDate"(newVal) {
      // 監聽結束日期變化，驗證不能小於開始日期和不能大於今天
      let error = "";

      // 檢查結束日期是否大於今天
      if (newVal && newVal > this.todayDate) {
        this.recordFilters.endDate = ""; // 清除無效的日期
        error = "結束日期不能大於今日";
      }
      // 檢查結束日期是否小於開始日期
      else if (
        this.recordFilters.startDate &&
        newVal &&
        newVal < this.recordFilters.startDate
      ) {
        error = "結束日期不能早於開始日期";
      }

      this.recordDateError = error;
    },

    "recordFilters.startDate"(newVal) {
      // 監聽開始日期變化，驗證結束日期和今天日期
      let error = "";

      // 檢查開始日期是否大於今天
      if (newVal && newVal > this.todayDate) {
        this.recordFilters.startDate = ""; // 清除無效的日期
        error = "開始日期不能大於今日";
      }
      // 檢查開始日期是否大於結束日期
      else if (
        this.recordFilters.endDate &&
        newVal &&
        newVal > this.recordFilters.endDate
      ) {
        error = "結束日期不能早於開始日期";
      }

      this.recordDateError = error;
    },
  },

  computed: {
    filteredInventory() {
      // 控制搜尋過濾區域
      if (!this.searchQuery) return this.inventory;
      return this.inventory.filter(
        (i) =>
          i.productName.includes(this.searchQuery) ||
          (i.variantName && i.variantName.includes(this.searchQuery)),
      );
    },

    totalPages() {
      // 控制分頁總頁數區域
      return Math.ceil(this.filteredInventory.length / this.itemsPerPage);
    },

    pagedInventory() {
      // 控制分頁資料切割區域
      const start = (this.currentPage - 1) * this.itemsPerPage;
      return this.filteredInventory.slice(start, start + this.itemsPerPage);
    },

    isAllSelected: {
      get() {
        if (this.pagedInventory.length === 0) return false;
        return this.pagedInventory.every((item) =>
          this.selectedIds.includes(item.id),
        );
      },
      set(value) {
        const pagedIds = this.pagedInventory.map((item) => item.id);
        if (value) {
          // 全選：將當前分頁中尚未被選取的 ID 加入
          pagedIds.forEach((id) => {
            if (!this.selectedIds.includes(id)) {
              this.selectedIds.push(id);
            }
          });
        } else {
          // 取消全選：將當前分頁中的 ID 從選取名單移除
          this.selectedIds = this.selectedIds.filter(
            (id) => !pagedIds.includes(id),
          );
        }
      },
    },

    filteredAdjustmentRecords() {
      // 控制庫存調整紀錄篩選區域
      // 檢查日期順序
      if (
        this.recordFilters.startDate &&
        this.recordFilters.endDate &&
        this.recordFilters.startDate > this.recordFilters.endDate
      ) {
        return []; // 日期順序錯誤，返回空陣列
      }

      return this.adjustmentRecords.filter((record) => {
        // 日期篩選
        if (this.recordFilters.startDate) {
          const recordDate = new Date(record.createdDate)
            .toISOString()
            .split("T")[0];
          if (recordDate < this.recordFilters.startDate) return false;
        }

        if (this.recordFilters.endDate) {
          const recordDate = new Date(record.createdDate)
            .toISOString()
            .split("T")[0];
          if (recordDate > this.recordFilters.endDate) return false;
        }

        // 人員篩選
        if (
          this.recordFilters.createdBy &&
          record.createdBy !== this.recordFilters.createdBy
        ) {
          return false;
        }

        return true;
      });
    },

    recordTotalPages() {
      // 庫存調整紀錄分頁總頁數
      return Math.ceil(
        this.filteredAdjustmentRecords.length / this.recordItemsPerPage,
      );
    },

    pagedAdjustmentRecords() {
      // 庫存調整紀錄分頁資料切割
      const start = (this.recordCurrentPage - 1) * this.recordItemsPerPage;
      return this.filteredAdjustmentRecords.slice(
        start,
        start + this.recordItemsPerPage,
      );
    },
  },

  methods: {
    // =============================
    // 計算今天的日期字符串
    // =============================
    getTodayString() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    // =============================
    // 從 API 獲取庫存調整紀錄
    // =============================
    async fetchAdjustmentRecords() {
      try {
        this.loading = true;
        let res = await api.get("/inventory/stock-log");

        if (res.data && res.data.data && Array.isArray(res.data.data)) {
          // 轉換 API 資料格式
          this.adjustmentRecords = res.data.data.map((item) => {
            return {
              id: item.Id || item.id,
              productId: item.ProductId || item.productId,
              productName: item.ProductName || item.productName || "",
              variantId: item.VariantId || item.variantId,
              variantName: item.VariantName || item.variantName,
              changeType: this.mapChangeType(
                item.ChangeType || item.changeType,
              ),
              changeQty: item.ChangeQty || item.changeQty || 0,
              beforeStock: item.BeforeStock || item.beforeStock || 0,
              afterStock: item.AfterStock || item.afterStock || 0,
              remark: item.Remark || item.remark || "",
              createdBy: item.CreatedBy || item.createdBy || "",
              createdDate: item.CreatedDate || item.createdDate,
            };
          });
          console.log(
            `✅ 成功載入 ${this.adjustmentRecords.length} 筆庫存調整紀錄`,
          );
        } else {
          console.warn("API 回應格式不符", res.data);
          this.adjustmentRecords = [];
        }
      } catch (e) {
        console.error("載入庫存調整紀錄錯誤", e);
        // 若 API 失敗，載入假資料作為備用
        this.initAdjustmentRecords();
        await showCustom({
          icon: "warning",
          title: "提示",
          text: "無法從伺服器載入調整紀錄，顯示緩存資料",
        });
      } finally {
        this.loading = false;
      }
    },

    // =============================
    // 轉換後端的異動類型代碼
    // =============================
    mapChangeType(backendType) {
      const typeMap = {
        in: "in",
        進貨: "in",
        out: "out",
        出貨: "out",
        adjust: "adjust",
        調整: "adjust",
        後台調整: "adjust",
      };
      return typeMap[backendType] || "adjust";
    },

    // =============================
    // 從 API 獲取員工列表
    // =============================
    async fetchEmployees() {
      try {
        let res = await api.get("/employee/all");

        if (res.data && res.data.data && Array.isArray(res.data.data)) {
          // 提取員工全名
          this.employees = res.data.data
            .map((item) => item.FullName || item.fullName)
            .filter((name) => name); // 過濾掉空值
          console.log(`✅ 成功載入 ${this.employees.length} 位操作人員`);
        } else {
          console.warn("員工 API 回應格式不符", res.data);
          this.employees = [];
        }
      } catch (e) {
        console.error("載入員工列表錯誤", e);
        this.employees = [];
      }
    },

    // =============================
    // 初始化庫存調整紀錄假資料（備用）
    // =============================
    initAdjustmentRecords() {
      this.adjustmentRecords = [
        {
          productId: 1,
          productName: "Apple iPhone 15",
          variantId: 101,
          variantName: "黑色 256GB",
          changeType: "in",
          changeQty: 50,
          beforeStock: 100,
          afterStock: 150,
          remark: "進貨單 PO-20240101",
          createdBy: "王小明",
          createdDate: new Date("2024-01-15T09:30:00"),
        },
        {
          productId: 1,
          productName: "Apple iPhone 15",
          variantId: 102,
          variantName: "白色 256GB",
          changeType: "out",
          changeQty: -20,
          beforeStock: 80,
          afterStock: 60,
          remark: "銷售訂單 SO-20240101",
          createdBy: "李美麗",
          createdDate: new Date("2024-01-14T14:15:00"),
        },
        {
          productId: 2,
          productName: "Samsung Galaxy S24",
          variantId: 201,
          variantName: "藍色 512GB",
          changeType: "adjust",
          changeQty: -5,
          beforeStock: 45,
          afterStock: 40,
          remark: "盤點調整",
          createdBy: "林志勇",
          createdDate: new Date("2024-01-13T10:45:00"),
        },
        {
          productId: 3,
          productName: "Google Pixel 8",
          variantId: 301,
          variantName: "綠色 128GB",
          changeType: "in",
          changeQty: 30,
          beforeStock: 70,
          afterStock: 100,
          remark: "進貨單 PO-20240102",
          createdBy: "陳芝芝",
          createdDate: new Date("2024-01-12T11:20:00"),
        },
        {
          productId: 2,
          productName: "Samsung Galaxy S24",
          variantId: 202,
          variantName: "黑色 256GB",
          changeType: "out",
          changeQty: -15,
          beforeStock: 55,
          afterStock: 40,
          remark: "退貨 SO-20240050",
          createdBy: "王小明",
          createdDate: new Date("2024-01-11T16:00:00"),
        },
        {
          productId: 1,
          productName: "Apple iPhone 15",
          variantId: 101,
          variantName: "黑色 256GB",
          changeType: "adjust",
          changeQty: 2,
          beforeStock: 148,
          afterStock: 150,
          remark: "盤點修正",
          createdBy: "李美麗",
          createdDate: new Date("2024-01-10T13:30:00"),
        },
        {
          productId: 3,
          productName: "Google Pixel 8",
          variantId: 302,
          variantName: "黑色 256GB",
          changeType: "in",
          changeQty: 25,
          beforeStock: 35,
          afterStock: 60,
          remark: "進貨單 PO-20240103",
          createdBy: "林志勇",
          createdDate: new Date("2024-01-09T09:15:00"),
        },
        {
          productId: 4,
          productName: "OnePlus 12",
          variantId: 401,
          variantName: "銀色 256GB",
          changeType: "out",
          changeQty: -10,
          beforeStock: 50,
          afterStock: 40,
          remark: "銷售訂單 SO-20240102",
          createdBy: "陳芝芝",
          createdDate: new Date("2024-01-08T15:45:00"),
        },
      ];
    },

    // =============================
    // 重設調整紀錄篩選
    // =============================
    resetRecordFilters() {
      this.recordFilters = {
        startDate: "",
        endDate: "",
        createdBy: "",
      };
      this.recordCurrentPage = 1; // 重設分頁為第一頁
    },

    // =============================
    // 刷新庫存調整紀錄（手動重新載入）
    // =============================
    async refreshAdjustmentRecords() {
      this.recordCurrentPage = 1; // 重設分頁
      this.recordFilters = {
        // 重設篩選
        startDate: "",
        endDate: "",
        createdBy: "",
      };
      await this.fetchAdjustmentRecords();
    },

    // =============================
    // 庫存調整紀錄分頁方法
    // =============================
    recordPrevPage() {
      if (this.recordCurrentPage > 1) this.recordCurrentPage--;
    },

    recordNextPage() {
      if (this.recordCurrentPage < this.recordTotalPages)
        this.recordCurrentPage++;
    },

    // =============================
    // 格式化異動類型顯示
    // =============================
    formatChangeType(changeType) {
      const typeMap = {
        in: "進貨",
        out: "出貨",
        adjust: "調整",
      };
      return typeMap[changeType] || changeType;
    },

    async loadInventory() {
      this.loading = true; // 控制載入開啟區域
      try {
        // 🔥 呼叫 Azure API
        let res = await api.get("/inventory/list");

        if (res.data && res.data.data) {
          // 轉換資料格式
          this.inventory = res.data.data.map((x) => {
            let safety = x.SafetyStock ?? 0;
            let status = "normal";
            if (x.Stock < safety) status = "low";
            if (x.Stock > safety * 2 && safety > 0) status = "high";

            return {
              id: `${x.ProductId}_${x.VariantId ?? "0"}`, // 組唯一ID
              productId: x.ProductId,
              variantId: x.VariantId,
              productName: x.ProductName,
              variantName: x.VariantName,
              stock: x.Stock,
              safetyStock: safety,
              status: status,
              updatedDate: x.UpdatedDate || "-",
              cost: x.CostPrice, // 成本（可能為 null 或 0）
            };
          });
        }
      } catch (e) {
        console.error("載入庫存錯誤", e);
      }
      this.loading = false; // 控制載入關閉區域
    },

    // 載入用戶角色
    async loadUserRole() {
      try {
        const res = await api.get("/back/admin/verify");
        if (res.data && res.data.success && res.data.data) {
          this.userRole = res.data.data.Role || "";
        }
      } catch (e) {
        console.error("載入用戶角色錯誤", e);
        this.userRole = "";
      }
    },

    // 判斷是否有權限查看成本
    canViewCost() {
      return this.userRole === "工程師" || this.userRole === "平台總管";
    },

    // 👉 格式化日期顯示
    formatDate(dateStr) {
      if (!dateStr || dateStr === "-") return "-";

      try {
        const date = new Date(dateStr);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      } catch (e) {
        return dateStr; // 若格式錯誤則返回原值
      }
    },

    handleSearch() {
      this.currentPage = 1; // 控制分頁重置區域
    },

    prevPage() {
      if (this.currentPage > 1) this.currentPage--;
    },

    nextPage() {
      if (this.currentPage < this.totalPages) this.currentPage++;
    },

    getStatusText(status) {
      // 控制狀態文字顯示區域
      if (status === "low") return "庫存偏低";
      if (status === "high") return "庫存過高";
      return "正常";
    },

    // =============================
    // 匯出「庫存報表」
    // =============================
    exportReport() {
      // 判斷是否有權限查看成本
      const showCost = this.canViewCost();

      // 控制開頭行區域
      const headers = [
        "商品名稱",
        "規格",
        "庫存量",
        "安全庫存",
        "更新日期",
        "狀態",
      ];

      // 如果有權限，加入成本和存貨價值欄位
      if (showCost) {
        headers.push("成本", "存貨價值");
      }

      // 控制資料映射區域
      const rows = this.inventory.map((x) => {
        const row = [
          x.productName,
          x.variantName || "-",
          x.stock,
          x.safetyStock,
          this.formatDate(x.updatedDate),
          this.getStatusText(x.status),
        ];

        // 如果有權限，加入成本和存貨價值
        if (showCost) {
          const cost = x.cost;
          if (cost === null || cost === undefined) {
            row.push("尚未設定", "尚未設定");
          } else {
            const inventoryValue = cost * x.stock;
            row.push(cost, inventoryValue);
          }
        }

        return row;
      });

      // 控制組裝CSV區域
      const csvContent = [
        "\ufeff" + headers.join(","), // 加 BOM → Excel 正確顯示UTF-8
        ...rows.map((r) => r.join(",")), // 資料列拼接
      ].join("\n");

      // 控制Blob建立區域
      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      // 控制下載檔案建立區域
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // 控制動態檔名區域
      const date = new Date().toISOString().slice(0, 10);
      link.download = `庫存報表_${date}.csv`;

      // 控制虛擬點擊區域
      link.click();
      URL.revokeObjectURL(url);
    },

    // =============================
    // 匯出「庫存盤點表」
    // =============================
    exportInventory() {
      // 控制盤點表標題區域
      const headers = [
        "商品ID",
        "規格ID",
        "商品名稱",
        "規格",
        "系統庫存",
        "安全庫存",
        "實際庫存(盤點填寫)",
        // "記錄人員",
        // "備註",
      ];

      // 控制資料映射區域（空欄位讓倉管填寫）
      const rows = this.inventory.map((x) => [
        x.productId,
        x.variantId || "",
        x.productName,
        x.variantName || "-",
        x.stock,
        x.safetyStock,
        "", // 實際盤點
        // "", // 記錄人員
        // "", // 備註
      ]);

      // 控制CSV組裝區域
      const csvContent = [
        "\ufeff" + headers.join(","), // BOM 防止亂碼
        ...rows.map((r) => r.join(",")), // 每列用 , 分隔
      ].join("\n");

      // 控制Blob建立區域
      const blob = new Blob([csvContent], {
        type: "text/csv;charset=utf-8;",
      });

      // 控制下載連結區域
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;

      // 控制檔案名稱區域
      const date = new Date().toISOString().slice(0, 10);
      link.download = `盤點報表_${date}.csv`;

      // 控制下載行為區域
      link.click();
      URL.revokeObjectURL(url);
    },

    // ✅ 匯入盤點報表 - 直接調整庫存
    async importInventory() {
      // 建立隱藏的 file input
      const fileInput = document.createElement("input");
      fileInput.type = "file";
      fileInput.accept = ".csv";

      fileInput.onchange = async (event) => {
        const file = event.target.files?.[0];
        if (!file) return;

        try {
          // 讀取 CSV 文件
          const text = await file.text();
          const lines = text.split("\n").filter((line) => line.trim());

          if (lines.length < 2) {
            showCustom({
              icon: "warning",
              title: "檔案格式錯誤",
              text: "CSV 文件至少需要標題行和一筆數據",
            });
            return;
          }

          // 解析 CSV 標題
          const headers = lines[0]
            .split(",")
            .map((h) => h.trim().replace(/"/g, ""));

          // 取得各欄位的索引 - 優先使用 ProductId/VariantId，退一步用商品名稱/規格
          const productIdIdx = headers.indexOf("商品ID");
          const variantIdIdx = headers.indexOf("規格ID");
          const productNameIdx = headers.indexOf("商品名稱");
          const variantNameIdx = headers.indexOf("規格");
          const actualStockIdx = headers.indexOf("實際庫存(盤點填寫)");
          const safetyStockIdx = headers.indexOf("安全庫存"); // 新增：安全庫存欄位

          // 檢查是否有必需欄位（至少需要實際庫存）
          if (actualStockIdx === -1) {
            showCustom({
              icon: "warning",
              title: "檔案欄位錯誤",
              text: "CSV 文件必須包含「實際庫存(盤點填寫)」欄位",
            });
            return;
          }

          // 檢查是否有ID欄位或名稱/規格欄位
          const hasIdFields = productIdIdx !== -1;
          const hasNameFields = productNameIdx !== -1 && variantNameIdx !== -1;

          if (!hasIdFields && !hasNameFields) {
            showCustom({
              icon: "warning",
              title: "檔案欄位錯誤",
              text: "CSV 文件必須包含「商品ID+規格ID」或「商品名稱+規格」欄位",
            });
            return;
          }

          // 批量更新庫存
          let successCount = 0;
          const failedItems = [];

          // 計算有效行數（用於進度計算）
          let validLineCount = 0;
          for (let i = 1; i < lines.length; i++) {
            const values = lines[i]
              .split(",")
              .map((v) => v.trim().replace(/"/g, ""));
            if (values.length > actualStockIdx) {
              const actualStockStr = values[actualStockIdx]?.trim() || "";
              if (actualStockStr) {
                validLineCount++;
              }
            }
          }

          // 顯示進度條
          Swal.fire({
            title: "正在匯入盤點報表...",
            html: `
              <div style="text-align: center;">
                <div style="margin: 20px 0;">
                  <span id="progress-text">0 / ${validLineCount}</span>
                </div>
                <div style="width: 100%; height: 20px; background: #ddd; border-radius: 10px; overflow: hidden;">
                  <div id="progress-bar" style="height: 100%; background: linear-gradient(90deg, #667eea, #764ba2); width: 0%; transition: width 0.3s;"></div>
                </div>
              </div>
            `,
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: async () => {
              // 開始處理
              let currentCount = 0;

              for (let i = 1; i < lines.length; i++) {
                try {
                  const values = lines[i]
                    .split(",")
                    .map((v) => v.trim().replace(/"/g, ""));

                  if (values.length <= actualStockIdx) {
                    continue; // 跳過格式不正確的行
                  }

                  const actualStockStr = values[actualStockIdx]?.trim() || "";

                  // ✅ 跳過空的實際庫存值
                  if (!actualStockStr) {
                    continue;
                  }

                  const actualStock = Number(actualStockStr);

                  // 跳過無效的庫存值（非數字）
                  if (isNaN(actualStock)) {
                    continue;
                  }

                  // 更新進度
                  currentCount++;
                  const progress = (currentCount / validLineCount) * 100;
                  document.getElementById("progress-bar").style.width =
                    progress + "%";
                  document.getElementById(
                    "progress-text",
                  ).textContent = `${currentCount} / ${validLineCount}`;

                  let matchedItem = null;
                  let matchMethod = "";

                  // 🎯 優先使用 ProductId + VariantId 直接匹配（最精確）
                  if (hasIdFields) {
                    const productId = values[productIdIdx]?.trim();
                    const variantId = values[variantIdIdx]?.trim();

                    if (productId) {
                      matchedItem = this.inventory.find(
                        (item) =>
                          item.productId == productId &&
                          (item.variantId || "") == (variantId || ""),
                      );
                      if (matchedItem) {
                        matchMethod = "ID匹配";
                      }
                    }
                  }

                  // 退一步：使用商品名稱 + 規格 匹配
                  if (!matchedItem && hasNameFields) {
                    const productName = values[productNameIdx]?.trim() || "";
                    const variantName = values[variantNameIdx]?.trim() || "";

                    if (!productName) {
                      failedItems.push(`第 ${i + 1} 行: 商品名稱為空`);
                      continue;
                    }

                    const normalizedVariant =
                      variantName === "-" ? "" : variantName;

                    // 灵活的variant匹配逻辑
                    matchedItem = this.inventory.find((item) => {
                      // 商品名稱必須完全相等
                      if (item.productName !== productName) return false;

                      // 規格匹配 - 支持多種格式
                      const itemVariant = item.variantName || "";

                      // 情況1：完全相等
                      if (itemVariant === normalizedVariant) return true;

                      // 情況2：數字開頭匹配（例如 "2" 匹配 "2.0" 或 "2.5"）
                      if (normalizedVariant && itemVariant) {
                        const csvNum = normalizedVariant.match(/^\d+/)?.[0];
                        const systemNum = itemVariant.match(/^\d+/)?.[0];
                        if (csvNum && systemNum && csvNum === systemNum) {
                          return true;
                        }
                      }

                      return false;
                    });

                    // Fallback機制：如果規格為空且系統中只有一個相同名稱
                    if (!matchedItem && normalizedVariant === "") {
                      const sameNameItems = this.inventory.filter(
                        (item) => item.productName === productName,
                      );
                      if (sameNameItems.length === 1) {
                        matchedItem = sameNameItems[0];
                        matchMethod = "Fallback匹配";
                      }
                    }

                    if (matchedItem && !matchMethod) {
                      matchMethod = "名稱規格匹配";
                    }
                  }

                  if (matchedItem) {
                    // 讀取安全庫存 - 優先使用 CSV 中的值，否則保持原值
                    let safetyStock = matchedItem.safetyStock; // 預設值
                    if (safetyStockIdx !== -1) {
                      const safetyStockStr = values[safetyStockIdx]?.trim();
                      if (safetyStockStr) {
                        const safetyStockNum = Number(safetyStockStr);
                        if (!isNaN(safetyStockNum)) {
                          safetyStock = safetyStockNum;
                        }
                      }
                    }

                    // 呼叫更新 API
                    await api.put("/inventory/update-stock", {
                      productId: matchedItem.productId,
                      variantId: matchedItem.variantId || null,
                      stock: actualStock,
                      safetyStock: safetyStock,
                      remark: "CSV盤點匯入",
                    });

                    // 本地同步更新
                    matchedItem.stock = actualStock;
                    successCount++;
                    console.log(
                      `✅ 第 ${i + 1} 行成功 [${matchMethod}]: ${
                        matchedItem.productName
                      } -> ${actualStock}`,
                    );
                  } else {
                    // 記錄失敗
                    let failReason = "無法匹配";
                    if (hasIdFields) {
                      const productId = values[productIdIdx]?.trim();
                      failReason = `ID (${productId}) 不存在`;
                    } else if (hasNameFields) {
                      const productName = values[productNameIdx]?.trim() || "";
                      failReason = `商品名稱 "${productName}" 無法匹配`;
                    }

                    failedItems.push(`第 ${i + 1} 行: ${failReason}`);
                    console.warn(`❌ 第 ${i + 1} 行失敗: ${failReason}`);
                  }
                } catch (rowError) {
                  console.warn(`第 ${i + 1} 行處理失敗`, rowError);
                }
              }

              // 關閉進度條並顯示結果
              Swal.close();

              // 顯示結果提示
              let message = `成功更新 ${successCount} 項商品`;
              if (failedItems.length > 0) {
                message += `\n\n${failedItems.length} 項未找到:\n${failedItems
                  .slice(0, 5)
                  .join("\n")}${
                  failedItems.length > 5
                    ? `\n... 共 ${failedItems.length} 項`
                    : ""
                }`;
              }

              showCustom({
                icon: successCount > 0 ? "success" : "warning",
                title: "匯入結果",
                text: message,
              });

              // 重新載入庫存
              await this.loadInventory();
            },
          });
        } catch (error) {
          showCustom({
            icon: "error",
            title: "匯入錯誤",
            text: error.message || "無法讀取或處理文件",
          });
        }
      };

      fileInput.click();
    },
    exportSingle(item) {
      alert(`匯出 ${item.productName} ${item.variantName || ""} 盤點表`);
    },

    // 👉 打開 Modal
    openAdjustModal(item) {
      this.adjustItem = {
        ...item,
        remark: "", // ⭐ 新增備註初始化
      };

      this.showAdjustModal = true;
    },

    closeAdjustModal() {
      this.showAdjustModal = false; // 控制 Modal 關閉區域
    },

    // 👉 批量調整相關
    openBatchAdjustModal() {
      if (this.selectedIds.length === 0) return;
      this.batchAdjustForm = { stock: null, safetyStock: null };
      this.showBatchModal = true;
    },

    closeBatchAdjustModal() {
      this.showBatchModal = false;
    },

    async saveBatchStock() {
      if (
        this.batchAdjustForm.stock === null &&
        this.batchAdjustForm.safetyStock === null
      ) {
        await showCustom({
          icon: "info",
          title: "提示",
          text: "請至少輸入一項修改數值",
        });
        return;
      }

      try {
        this.loading = true;

        // 取得選取的原始項目資料
        const selectedItems = this.inventory.filter((item) =>
          this.selectedIds.includes(item.id),
        );

        // 依次呼叫更新 API (或後端有批次 API 則更佳)
        for (const item of selectedItems) {
          const updateData = {
            productId: item.productId,
            variantId: item.variantId,
            stock:
              this.batchAdjustForm.stock !== null
                ? this.batchAdjustForm.stock
                : item.stock,
            safetyStock:
              this.batchAdjustForm.safetyStock !== null
                ? this.batchAdjustForm.safetyStock
                : item.safetyStock,
          };
          await api.put("/inventory/update-stock", updateData);
        }

        await showCustom({
          icon: "success",
          title: "批量修改成功",
          text: `已更新 ${this.selectedIds.length} 項商品`,
        });

        this.selectedIds = []; // 清空選取
        this.closeBatchAdjustModal();
        await this.loadInventory(); // 重新載入
      } catch (e) {
        console.error("批量儲存錯誤", e);
        await showCustom({
          icon: "error",
          title: "修改失敗",
          text: "部分或全部商品更新失敗",
        });
      } finally {
        this.loading = false;
      }
    },

    // 👉 儲存庫存
    async saveStock() {
      try {
        await api.put("/inventory/update-stock", {
          productId: this.adjustItem.productId,
          variantId: this.adjustItem.variantId,
          stock: this.adjustItem.stock,
          safetyStock: this.adjustItem.safetyStock,
          remark: this.adjustItem.remark || "",
        });

        // 更新本地資料
        let idx = this.inventory.findIndex((i) => i.id === this.adjustItem.id);
        if (idx !== -1) {
          this.inventory[idx].stock = this.adjustItem.stock;
          this.inventory[idx].safetyStock = this.adjustItem.safetyStock;
        }

        this.closeAdjustModal(); // 控制 Modal 關閉區域

        // 👉 顯示成功通知                     // 控制成功通知區域
        await showCustom({
          icon: "success",
          title: "修改成功",
          text: "庫存已更新完成",
        });
        this.loadInventory(); // 重新載入資料
      } catch (e) {
        console.error("儲存資料錯誤", e);

        await showCustom({
          icon: "error",
          title: "修改失敗",
          text: "請稍後再試一次",
        });
      }
    },
  },
};
